var map = {
	"./cnn-money-x2.png": 2028,
	"./cnn-money.png": 2238,
	"./economist-x2.png": 2029,
	"./economist.png": 2239,
	"./mashable-x2.png": 2030,
	"./mashable.png": 2240,
	"./tech-crunch-x2.png": 2031,
	"./tech-crunch.png": 2241,
	"./thenewyorker-x2.png": 2032,
	"./thenewyorker.png": 2242,
	"./thrillist-x2.png": 2033,
	"./thrillist.png": 2243,
	"./time-x2.png": 2034,
	"./time.png": 2244,
	"./usa-today-x2.png": 2035,
	"./usa-today.png": 2245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2237;